import React, {useEffect}				from 'react';

import Icon								from '../Icon';
import Button 							from '../Button';
import MultiInputContainer				from '../Input/MultiInputContainer';

import {useAppSelector}					from '../../../app/hooks';
import {ModalProps}						from './interface';

import img_close						from '../../images/icon/close.svg';

import LANGUAGE							from '../../language';

import './Modal.css';


function	Modal(props: ModalProps) {
	const lang = useAppSelector(state => state.settings.lang);

	const TEXTE = LANGUAGE(lang);

	useEffect(() => {
		const productFruitButton = document.getElementsByClassName('modern-reset button-launcher')[0] as HTMLElement | undefined;

		if (productFruitButton)
			productFruitButton.style.visibility = 'hidden';

		return () => {
			if (productFruitButton)
				productFruitButton.style.visibility = 'initial';
		};
	}, []);

	return (
		<div
			onClick={() => props.onClose && props.onClose()}
			className={`modal ${props.modalRight && 'modalRight'} ${props.fullWidth && 'full'}`}
		>
			<div onClick={e => e.stopPropagation()} style={{width: props.size}}>
				<div className={`modalHeader ${props.headerSeparation && 'border'}`}>
					<div>{props.header}</div>
					{props.onClose &&
						<Icon
							iconSize={12}
							icon={img_close}
							iconColor={'#667085'}
							onClick={() => (props.onClose ? props.onClose() : null)}
						/>
					}
				</div>

				<div
					style={{
						...props.overflowDisabled ? {overflow: 'unset'} : {},
						...props.gap ? {gap: props.gap} : {}
					}}
					className={`modalBody ${props.noPadding && 'noPadding'}`}
				>
					{props.children}
				</div>

				{(props.cancelButton || props.confirmButton || props.footer) &&
					<div className={`modalFooter ${props.footerSeparation && 'border'}`}>
						{props.footer}
						{(props.cancelButton || props.confirmButton) &&
							<MultiInputContainer flexDirection={props.footerFlexDirection}>
								{props.cancelButton &&
									<Button
										fullWidth
										type={'secondary-gray'}
										onClick={props.cancelButton}
									>
										{props.cancelButtonText || TEXTE.global.cancel}
									</Button>
								}
								{props.confirmButton &&
									<Button
										fullWidth
										isLoad={props.confirmLoad}
										onClick={props.confirmButton}
										disabled={props.confirmButtonDisabled}
									>
										{props.confirmButtonText || TEXTE.global.confirm}
									</Button>
								}
							</MultiInputContainer>
						}
					</div>
				}
			</div>
		</div>
	);
}

export default Modal;
